<script setup lang="ts">
withDefaults(defineProps<{ logoSrc?: string; logoLoading?: boolean }>(), {
  logoSrc: undefined,
  logoLoading: false,
})
</script>

<template>
  <header class="header container">
    <!--new-->
    <router-link v-if="logoLoading || logoSrc" class="header__logo-link" :to="'#'">
      <div v-if="logoLoading" class="header__logo-skeleton" />
      <img
        v-else
        class="header__logo-image"
        :src="logoSrc"
        alt=""
        width="156"
        height="28"
        loading="lazy"
      />
    </router-link>
  </header>
</template>

<style lang="scss">
@use '@/styles/helpers' as *;

.header {
  margin-bottom: fluid(26, 20);
  padding-top: fluid(26, 8);

  &__logo-image {
    user-select: none;
  }

  &__logo-skeleton {
    width: 156px;
    height: 28px;
    border-radius: 4px;
    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s infinite;
  }
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
